import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  getRoles(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiLocations.identity}/Roles?PageIndex=0&PageSize=10`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
